import { render, staticRenderFns } from "./Guesthouses.vue?vue&type=template&id=2def3601"
import script from "./Guesthouses.vue?vue&type=script&lang=js"
export * from "./Guesthouses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports